/**
 * GRN (Goods Receipt Note) Routes
 * Centralized route paths for GRN module navigation
 */

// ============================================
// GRN FEATURE ROUTES
// ============================================
export const GRN_ROUTES = {
  // Main GRN Routes
  LIST: "/vaddgrn",
  CREATE: "/CreateGrn",
  EDIT: "/EditGrn",
  View_TEP_HISTORY: "/vgrnpage",

  // View Routes
  VIEW_DETAIL: "/ViewDetailGrn",
  VIEW_INITIATOR: "/vaddgrn",
  VIEW_APPROVER: "/vgrnapprovals",
  VIEW_HISTORY: "/vgrnhistory",
   VIEW_GRN_FULLHISTORY: "/ViewGrnHistory",
 

  // Return Routes
  RETURN_GRN: "/vreturngrn",
  EDIT_RETURN: "/Editreturngrn",
  VIEW_RETURN: "/ReturnGrn",
  VIEW_RETURN_DETAIL: "/ViewDetailsreturnGrn",
   VIEW_RETURN_DETAIL_EDIT: "/ViewDetailsreturneditGrn",
  GOODS_RETURN_HISTORY: "/vgoodsrtnhistory",
  GOODS_RETURN_HISTORY_BY_ID: "/vgoodsrtnhistorybyid",
  VIEW_HOOD_RETURN_APPROVAL: "/vreturnapprovals",
   VIEW_RETURN_GRN_DETAIL: "/ViewReturnGrnDetails",
   VIEW_RETURN_GRN_DETAIL_1: "/ViewReturnsGrnDetails",
   VIEW_GRN_HISTORY: "/vgrnhistory",
   VIEW_GRN_NOTES: "/vgrnnotes",
   VIEW_MY_ACTION_INITIATOR: "/vmyactionsinitiator",
   VIEW_MY_ACTION_APPROVER: "/vmyactionsapprover",
   
};

// ============================================
// RELATED MODULE ROUTES
// ============================================
export const RELATED_ROUTES = {
  // Supplier
  SUPPLIER_LIST: "/suppliers",
  SUPPLIER_ADD: "/vaddsupplier",
  SUPPLIER_VIEW: "/view-supplier",

  // Product
  PRODUCT_LIST: "/products",
  PRODUCT_ADD: "/add-product",
  PRODUCT_VIEW: "/view-product",

  // Dashboard
  DASHBOARD: "/dashboard",
  HOME: "/",
};

// ============================================
// DOCUMENT ROUTES
// ============================================
export const DOCUMENT_ROUTES = {
  GRN_PDF: "/grn-pdf",
  RETURN_NOTE_PDF: "/return-note-pdf",
  DEBIT_NOTE_PDF: "/debit-note-pdf",
  REJECTION_NOTE_PDF: "/rejection-note-pdf",
};

// ============================================
// HELPER FUNCTIONS FOR ROUTE BUILDING
// ============================================

/**
 * Build GRN detail route with ID
 * @param {string} grnId - GRN ID
 * @returns {string} - Complete route path
 */
export const buildGrnDetailRoute = (grnId) => {
  return `${GRN_ROUTES.VIEW_DETAIL}?id=${grnId}`;
};

/**
 * Build GRN edit route with ID
 * @param {string} grnId - GRN ID
 * @returns {string} - Complete route path
 */
export const buildGrnEditRoute = (grnId) => {
  return `${GRN_ROUTES.EDIT}?id=${grnId}`;
};

/**
 * Build return GRN route with ID
 * @param {string} grnId - GRN ID
 * @returns {string} - Complete route path
 */
export const buildReturnGrnRoute = (grnId) => {
  return `${GRN_ROUTES.RETURN_GRN}?id=${grnId}`;
};

/**
 * Build view return GRN detail route with ID
 * @param {string} returnId - Return GRN ID
 * @returns {string} - Complete route path
 */
export const buildViewReturnDetailRoute = (returnId) => {
  return `${GRN_ROUTES.VIEW_RETURN_DETAIL}?id=${returnId}`;
};

/**
 * Navigate back to GRN list
 * @param {function} navigate - React Router navigate function
 */
export const navigateToGrnList = (navigate) => {
  navigate(GRN_ROUTES.LIST);
};

/**
 * Navigate to GRN detail with optional delay
 * @param {function} navigate - React Router navigate function
 * @param {string} grnId - GRN ID (optional)
 * @param {number} delay - Delay in milliseconds (optional)
 */
export const navigateToGrnDetail = (navigate, grnId = null, delay = 0) => {
  const route = grnId ? buildGrnDetailRoute(grnId) : GRN_ROUTES.VIEW_DETAIL;

  if (delay > 0) {
    setTimeout(() => {
      navigate(route);
    }, delay);
  } else {
    navigate(route);
  }
};
